(function () {
  // This file is requested by whichever surface renders the buy box (the
  // product section, the collection grid's quick-view popups). Bail out on a
  // second execution so a page pulling it in twice can't end up with two sets
  // of document-level listeners running every update twice per click.
  if (window.buyBoxVariantPickerLoaded) return;
  window.buyBoxVariantPickerLoaded = true;

  function getForm(el) {
    return el.closest('main-product-form');
  }

  function getAllVariants(form) {
    var jsonEl = form.querySelector('.productjson');
    if (!jsonEl) return [];
    try {
      return JSON.parse(jsonEl.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function findVariant(form, quantityValue, flavourValue) {
    var jsonEl = form.querySelector('.productjson');
    if (!jsonEl) return null;

    var quantityIndex = jsonEl.getAttribute('data-quantity-option-index');
    var flavourIndex = jsonEl.getAttribute('data-flavour-option-index');
    var variants = getAllVariants(form);

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var quantityMatches = v['option' + quantityIndex] === quantityValue;
      var flavourMatches =
        !flavourValue || !flavourIndex || flavourIndex === '0' || v['option' + flavourIndex] === flavourValue;
      if (quantityMatches && flavourMatches) return v;
    }
    return null;
  }

  function getSelectedFlavourValue(form) {
    var selectedFlavour = form.querySelector('.flavour-pill.is-selected');
    return selectedFlavour ? selectedFlavour.getAttribute('data-flavour-value') : null;
  }

  function isSubscriptionSelected(form) {
    var checked = form.querySelector('.rc-radio__input:checked');
    return !!checked && checked.value === 'subscription';
  }

  function formatMoney(cents) {
    var symbol = document.body.getAttribute('data-currency') || '';
    return Shopify.formatMoney(cents, symbol + '{{amount}}');
  }

  function getSellingPlanNamesMap(form) {
    var mapEl = form.querySelector('.selling-plan-names-map');
    if (!mapEl) return {};
    try {
      return JSON.parse(mapEl.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  // product.variants | json (the .productjson script tag) serializes each
  // selling plan allocation with only a flat selling_plan_id, not a nested
  // selling_plan object with its own name — the real name has to be looked
  // up from the separate selling-plan-names-map script tag instead.
  function getSellingPlanName(form, allocation) {
    var namesMap = getSellingPlanNamesMap(form);
    return namesMap[String(allocation.selling_plan_id)] || '';
  }

  // A variant may offer just one selling plan (3/6/9 Bags) or many (1 Bag,
  // every 1-12 weeks) — the hidden .variant-item's own data-sellingplan
  // attribute is the single source of truth for which plan is currently
  // active for that variant (seeded server-side, updated by the frequency
  // picker), so check that first. Falls back to the same heuristic used
  // server-side (4-week plan for single bags, otherwise the plan whose name
  // mentions the pack size) for a variant that hasn't been touched yet.
  function resolveSellingPlanAllocation(form, variant, packsize) {
    var allocations = variant.selling_plan_allocations || [];
    if (!allocations.length) return null;

    var hiddenRadio = form.querySelector('.variant-item[value="' + variant.id + '"]');
    var activePlanId = hiddenRadio && hiddenRadio.getAttribute('data-sellingplan');
    if (activePlanId) {
      var active = allocations.filter(function (allocation) {
        return String(allocation.selling_plan_id) === String(activePlanId);
      })[0];
      if (active) return active;
    }

    var chosen = allocations[0];
    allocations.forEach(function (allocation) {
      var planName = getSellingPlanName(form, allocation);
      if (packsize === 1) {
        if (planName.indexOf('4') !== -1) chosen = allocation;
      } else if (planName.indexOf(String(packsize)) !== -1) {
        chosen = allocation;
      }
    });
    return chosen;
  }

  // Price comes from the matched selling plan allocation when subscribing
  // (otherwise the plain variant) — no computed/guessed bundle price. The
  // compare price always comes from the VARIANT's own compare_at_price, even
  // while subscribing — Recharge sets a selling plan allocation's own
  // compare_at_price to the plain one-time price, which is not the
  // strikethrough value the merchant wants shown here; they set the real one
  // directly on the variant. The "XX% OFF" badge is a Subscribe & Save
  // incentive though, so One Time Purchase never shows a compare price here
  // even if the variant genuinely has one, falling back to the plain total
  // price badge instead.
  function resolveCardPricing(form, variant, packsize) {
    if (isSubscriptionSelected(form) && variant.selling_plan_allocations && variant.selling_plan_allocations.length) {
      var allocation = resolveSellingPlanAllocation(form, variant, packsize);
      var comparePrice = variant.compare_at_price;
      // 1 Bag/Bottle is the one exception: its % OFF always comes from THIS
      // variant's own one-time price versus its Subscribe & Save price,
      // full stop — never from compare_at_price. Mirrors
      // subscription-buy-box.liquid's server-side rendering of the exact
      // same card.
      if (packsize === 1) {
        comparePrice = variant.price;
      }
      return { price: allocation.price, comparePrice: comparePrice };
    }
    return { price: variant.price, comparePrice: 0 };
  }

  // Each card's price + savings badge depend on BOTH the currently selected
  // flavour (resolves which variant this quantity maps to) and whether
  // Subscribe & Save or One Time Purchase is selected — re-run on either
  // change so cards never show a stale purchase-option's price.
  function updateQuantityCardPrices(form) {
    var variants = getAllVariants(form);
    if (!variants.length) return;
    var flavourValue = getSelectedFlavourValue(form);
    var eachPriceOverrides = getVariantEachPriceMap(form);

    form.querySelectorAll('.quantity-card').forEach(function (card) {
      var quantityValue = card.getAttribute('data-quantity-value');
      var packsize = parseInt(card.getAttribute('data-packsize'), 10) || 1;
      var variant = findVariant(form, quantityValue, flavourValue);
      if (!variant) return;

      var pricing = resolveCardPricing(form, variant, packsize);
      var price = pricing.price;
      var comparePrice = pricing.comparePrice;

      var priceEl = card.querySelector('.quantity-card__price');
      if (priceEl) {
        var eachEl = priceEl.querySelector('.quantity-card__each');
        // custom.custom_each_price overrides just this "£xxxx" part (see
        // subscription-buy-box.liquid) — e.g. a 2+1 Free variant showing the
        // 1x subscription unit price instead of its own computed
        // bundle-per-unit price. Re-checked here, not only server-side,
        // because this same function overwrites priceEl on every
        // flavour/purchase-option change.
        var eachPriceOverride = eachPriceOverrides[String(variant.id)];
        var eachPrice = Math.round(price / packsize);
        priceEl.textContent = eachPriceOverride || formatMoney(eachPrice);
        if (!eachEl) {
          eachEl = document.createElement('span');
          eachEl.className = 'quantity-card__each';
          eachEl.textContent = '/each';
        }
        priceEl.appendChild(eachEl);
      }

      // The badge slot always shows something: the real discount % when this
      // variant/plan has a genuine compare-at price, otherwise the plain
      // total price for this quantity — never left empty.
      var savePercent =
        comparePrice > price ? Math.round(((comparePrice - price) * 100) / comparePrice) : 0;
      var saveEl = card.querySelector('.quantity-card__save');
      if (!saveEl) {
        saveEl = document.createElement('span');
        saveEl.className = 'quantity-card__save';
        card.appendChild(saveEl);
      }
      if (savePercent > 0) {
        saveEl.classList.remove('quantity-card__save--total');
        saveEl.textContent = savePercent + '% OFF';
      } else {
        saveEl.classList.add('quantity-card__save--total');
        saveEl.textContent = formatMoney(price);
      }
    });
  }

  function resolveVariant(form) {
    var selectedQuantity = form.querySelector('.quantity-card.is-selected');
    if (!selectedQuantity) return null;
    var quantityValue = selectedQuantity.getAttribute('data-quantity-value');
    return findVariant(form, quantityValue, getSelectedFlavourValue(form));
  }

  // The gallery only ever shows the generic (non-variant) media — the client
  // does not want it switching to a variant's own image on flavour/quantity
  // change, so custom-product-media-gallery.liquid excludes variant-tagged
  // media from the DOM entirely and this picker never touches the gallery.
  function syncHiddenVariant(form) {
    var variant = resolveVariant(form);
    if (!variant) return;

    var hiddenRadio = form.querySelector('.variant-item[value="' + variant.id + '"]');
    if (!hiddenRadio || hiddenRadio.checked) return;

    hiddenRadio.click();
  }

  // Reads the frequency straight off the card that was just selected (e.g.
  // "every 9 weeks") instead of assuming "months" — keeps this in sync with
  // whatever real Recharge selling plan data that card is already showing.
  function updateShipFrequency(form, card) {
    var label = form.querySelector('[data-ship-frequency]');
    if (!label || !card) return;
    var freqEl = card.querySelector('.quantity-card__frequency');
    var freqText = freqEl ? freqEl.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!freqText) return;
    label.textContent = 'Ships ' + freqText;
  }

  // One Time Purchase has no recurring delivery, so "every 4 weeks" (which
  // reads as a recurring shipment) becomes "4 weeks supply" instead — same
  // dynamic text every card already shows, just with the leading "every "
  // dropped and "supply" appended on toggle instead of re-derived.
  // data-frequency-base (set server-side in subscription-buy-box.liquid) is
  // the single source of truth for the raw text so this never has to guess
  // at pack size/interval itself.
  function updateQuantityCardFrequency(form) {
    var subscribing = isSubscriptionSelected(form);
    form.querySelectorAll('.quantity-card__frequency-text').forEach(function (el) {
      var base = el.getAttribute('data-frequency-base') || '';
      if (subscribing || !base) {
        el.textContent = base;
        return;
      }
      el.textContent = base.replace(/^every\s+/i, '') + ' supply';
    });
  }

  function getVariantLabelMap(form) {
    var mapEl = form.querySelector('.variant-label-map');
    if (!mapEl) return {};
    try {
      return JSON.parse(mapEl.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  function getVariantEachPriceMap(form) {
    var mapEl = form.querySelector('.variant-each-price-map');
    if (!mapEl) return {};
    try {
      return JSON.parse(mapEl.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  // Each quantity card's custom label depends on the card's own quantity
  // value, whichever flavour is currently selected (custom label lives on
  // the variant metafield, and flavour+quantity together resolve a variant),
  // AND whether Subscribe & Save is selected — the label is a subscription
  // perk, so One Time Purchase always shows the real variant name instead.
  // The ribbon/"+1 FREE" text and the position tag are driven by the exact
  // same "does this card's currently-resolved variant have a custom label"
  // check, so they're toggled here too instead of only ever reflecting
  // whichever variant happened to be selected at page load.
  // Re-run whenever flavour or the purchase option changes.
  function updateQuantityCardLabels(form) {
    var labelMap = getVariantLabelMap(form);
    var flavourValue = getSelectedFlavourValue(form);
    var subscribing = isSubscriptionSelected(form);

    form.querySelectorAll('.quantity-card').forEach(function (card) {
      var quantityValue = card.getAttribute('data-quantity-value');
      var titleEl = card.querySelector('.quantity-card__title');
      if (!titleEl) return;

      var variant = findVariant(form, quantityValue, flavourValue);
      var label = subscribing && variant && labelMap[String(variant.id)];
      titleEl.textContent = label || quantityValue;

      var hasCustomLabel = !!label;
      var ribbonEl = card.querySelector('.quantity-card__ribbon');
      var tagEl = card.querySelector('.quantity-card__tag');
      var extraEl = card.querySelector('.quantity-card__extra');
      if (ribbonEl) ribbonEl.classList.toggle('is-hidden', !hasCustomLabel);
      if (tagEl) tagEl.classList.toggle('is-hidden', hasCustomLabel);
      if (extraEl) extraEl.classList.toggle('is-hidden', !hasCustomLabel);
    });
  }

  // A quantity that's out of stock for one flavour may be in stock for
  // another, so re-check every card's availability whenever flavour changes.
  // If the currently selected card just went out of stock, fall back to the
  // first still-available one instead of leaving a hidden card selected.
  function updateQuantityCardAvailability(form) {
    var flavourValue = getSelectedFlavourValue(form);
    var cards = Array.prototype.slice.call(form.querySelectorAll('.quantity-card'));
    var selectedCard = null;

    cards.forEach(function (card) {
      var quantityValue = card.getAttribute('data-quantity-value');
      var variant = findVariant(form, quantityValue, flavourValue);
      var available = !!variant && variant.available;
      card.classList.toggle('is-out-of-stock', !available);
      card.classList.remove('is-row-solo');
      if (card.classList.contains('is-selected')) selectedCard = card;
    });

    if (selectedCard && selectedCard.classList.contains('is-out-of-stock')) {
      var firstAvailable = cards.filter(function (card) {
        return !card.classList.contains('is-out-of-stock');
      })[0];
      if (firstAvailable) {
        selectedCard.classList.remove('is-selected');
        firstAvailable.classList.add('is-selected');
        updateShipFrequency(form, firstAvailable);
      }
    }

    // Mobile's quantity grid is 3 columns (subscription-buy-box.liquid). A
    // card left alone below a full row of 3 spans the whole row instead of
    // sitting stranded next to empty cells. Based on VISIBLE count, not raw
    // DOM position — the flavour just resolved above can hide any card via
    // is-out-of-stock, and a hidden card still occupies a DOM/nth-child slot
    // even though it renders nothing.
    var visibleCards = cards.filter(function (card) {
      return !card.classList.contains('is-out-of-stock');
    });
    if (visibleCards.length % 3 === 1) {
      visibleCards[visibleCards.length - 1].classList.add('is-row-solo');
    }
  }

  function getVariantCashRewardsMap(form) {
    var mapEl = form.querySelector('.variant-cash-rewards-map');
    if (!mapEl) return {};
    try {
      return JSON.parse(mapEl.textContent) || {};
    } catch (e) {
      return {};
    }
  }

  // Cash rewards banner is fully variant-driven (custom.enable_cash_rewards +
  // custom.cash_rewards_text metafields) — show/hide and set its text based on
  // whichever variant flavour+quantity currently resolves to.
  function updateCashRewardsBanner(form) {
    var banner = form.querySelector('.cash-rewards-banner');
    if (!banner) return;

    var variant = resolveVariant(form);
    var rewardsMap = getVariantCashRewardsMap(form);
    var text = variant && rewardsMap[String(variant.id)];

    var textEl = banner.querySelector('.cash-rewards-banner__text');
    if (text) {
      if (textEl) textEl.textContent = text;
      banner.classList.remove('hidden');
    } else {
      banner.classList.add('hidden');
    }
  }

  // The gift box and cash rewards banner normally supply the visual
  // breathing room above the "Ships every..." delivery summary themselves —
  // when a product has neither (no gift products configured at all, and no
  // variant with cash rewards currently showing), that summary reads as
  // cramped right under the quantity cards with only its own small default
  // margin. offsetParent === null catches "not actually visible" however it
  // happened — the banner's own .hidden class, or the .onetime CSS rule that
  // hides it while One Time Purchase is selected — instead of re-checking
  // each mechanism separately, so this stays correct through flavour,
  // quantity, AND purchase-option changes alike.
  function updateDeliverySummarySpacing(form) {
    var keys = form.querySelector('.subscription-keys');
    if (!keys) return;
    var hasGiftBox = !!form.querySelector('.gift-box');
    var cashBanner = form.querySelector('.cash-rewards-banner');
    var cashVisible = !!cashBanner && cashBanner.offsetParent !== null;
    keys.classList.toggle('subscription-keys--tight', !hasGiftBox && !cashVisible);
  }

  document.addEventListener('click', function (event) {
    var flavourPill = event.target.closest('.flavour-pill');
    if (flavourPill) {
      var flavourForm = getForm(flavourPill);
      if (!flavourForm) return;
      flavourForm.querySelectorAll('.flavour-pill').forEach(function (pill) {
        pill.classList.remove('is-selected');
      });
      flavourPill.classList.add('is-selected');
      updateQuantityCardLabels(flavourForm);
      updateQuantityCardPrices(flavourForm);
      updateQuantityCardAvailability(flavourForm);
      syncHiddenVariant(flavourForm);
      updateCashRewardsBanner(flavourForm);
      updateDeliverySummarySpacing(flavourForm);
      return;
    }

    var quantityCard = event.target.closest('.quantity-card');
    if (quantityCard) {
      var quantityForm = getForm(quantityCard);
      if (!quantityForm) return;
      quantityForm.querySelectorAll('.quantity-card').forEach(function (card) {
        card.classList.remove('is-selected');
      });
      quantityCard.classList.add('is-selected');
      updateShipFrequency(quantityForm, quantityCard);
      syncHiddenVariant(quantityForm);
      updateCashRewardsBanner(quantityForm);
      updateDeliverySummarySpacing(quantityForm);
    }
  });

  document.addEventListener('change', function (event) {
    if (!event.target.classList || !event.target.classList.contains('rc-radio__input')) return;
    var form = getForm(event.target);
    if (!form) return;
    updateQuantityCardPrices(form);
    updateQuantityCardLabels(form);
    updateQuantityCardFrequency(form);
    // The "Ships ..." summary (subscription mode only) is a copy of the
    // selected card's own frequency text, taken at whatever moment it was
    // last set — a click on a quantity card while One Time Purchase was
    // selected, or the page's own initial state. Switching purchase option
    // back to Subscribe & Save updates every card's frequency text above,
    // but nothing re-copied that into the ships label, so it kept showing
    // the stale One Time Purchase wording (e.g. "Ships 6 Months Supply")
    // instead of the freshly-toggled "every 6 months". Re-copy it here too,
    // from whichever card is currently selected, same as a card click does.
    var selectedCard = form.querySelector('.quantity-card.is-selected');
    if (selectedCard) updateShipFrequency(form, selectedCard);
    // Purchase-option toggle also flips .onetime/.subscription on the
    // ancestor wrapper (see global.js), which is what actually hides the
    // cash rewards banner in One Time Purchase mode — re-check spacing here
    // too, not just on flavour/quantity change.
    updateDeliverySummarySpacing(form);
  });

  function initBuyBoxes(root) {
    (root || document).querySelectorAll('main-product-form').forEach(function (form) {
      updateQuantityCardLabels(form);
      updateQuantityCardPrices(form);
      updateQuantityCardAvailability(form);
      updateQuantityCardFrequency(form);
      updateCashRewardsBanner(form);
      updateDeliverySummarySpacing(form);
    });
  }

  // Exposed so markup that appears after page load can be brought up to the
  // same state — the collection grid replaces its whole product list (and with
  // it every card's quick-view buy box) whenever a filter is applied, and those
  // fresh cards would otherwise keep their raw server-rendered labels.
  window.initBuyBoxVariantPickers = initBuyBoxes;

  document.addEventListener('DOMContentLoaded', function () {
    initBuyBoxes(document);
  });
})();
